import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { IItem, updateItem } from '../../slices/inventorySlice';
import { toServer } from '../../util/ServerSocket';
import { prompt } from '../../util/EventEmitter';
import { MultilineLabel } from '../../components/UI/MultilineLabel';
import JPanel from '../../components/UI/JPanel';

interface ArmoryInfo { level: number; cost: number; rate: number; valid: boolean; success?: boolean; error?: string; item?: IItem; }
export function useArmoryAttempt(getInfo: string, attempt: string, item: IItem | undefined, material?: IItem, materialCost?: string) {
  const dispatch = useAppDispatch();
  const stones = useAppSelector(state => state.currency.stones);
  const [info, setInfo] = useState<ArmoryInfo>({ level: 0, cost: 0, rate: 0, valid: false });
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);
  const busy = useRef(false);
  useEffect(() => {
    let mounted = true;
    toServer(getInfo, {}, (response: ArmoryInfo) => { if (mounted) setInfo(response); });
    return () => { mounted = false; };
  }, [getInfo, item, material]);
  useEffect(() => { setResult(null); }, [item?.uid]);
  function onAttempt() {
    if (busy.current || !info.valid || stones < info.cost) return;
    prompt(`ยืนยันทำรายการ ค่าใช้จ่าย ${info.cost.toLocaleString()} หิน${materialCost ? ' และ ' + materialCost : ''} โอกาสสำเร็จ ${info.rate}%?`, () => {
      if (busy.current) return;
      busy.current = true; setLoading(true); setResult(null);
      const timer = window.setTimeout(() => { busy.current = false; setLoading(false); }, 10000);
      toServer(attempt, { level: info.level, cost: info.cost }, (response: ArmoryInfo) => {
        window.clearTimeout(timer); busy.current = false; setLoading(false);
        setInfo(response);
        if (!response.error) {
          setResult(response.success ?? null);
          if (response.item) dispatch(updateItem(response.item));
        }
      });
    });
  }
  return { info, result, loading, onAttempt, disabled: !info.valid || stones < info.cost || loading };
}

export function ArmoryFeedback({ cost, rate, result }: { cost: number; rate: number; result: boolean | null }) {
  return <>
    <JPanel size={{ width: 110, height: 22 }} position={{ x: 6, y: 126 }} background="UIResource.Common.BigBG4">
      <MultilineLabel size={{ width: 110, height: 20 }} position={{ x: 0, y: 3 }} text={`Rate: ${rate}%`} style={{ textAlign: 'center' }} />
    </JPanel>
    <MultilineLabel size={{ width: 106, height: 34 }} position={{ x: 100, y: 96 }} text={`ค่าใช้จ่าย: ${cost.toLocaleString()} หิน`} style={{ textAlign: 'center' }} />
    <MultilineLabel size={{ width: 50, height: 17 }} position={{ x: 220, y: 130 }} text="Result:" />
    <MultilineLabel size={{ width: 85, height: 17 }} position={{ x: 275, y: 130 }} text={result === null ? '' : result ? 'Success' : 'Failed'} />
  </>;
}
